<template>
  <div>
    <div class="my-16">
      <v-img src="logo.svg" contain height="150"></v-img>
    </div>
    <div>
      <v-text-field color="#107ed9" v-model="lk_login" label="Логин" required outlined></v-text-field>
      <v-text-field color="#107ed9" type="password" v-model="lk_passwd" label="Пароль" required outlined></v-text-field>
      <v-btn block color="#eb880e" dark x-large @click="goAuth">Вход</v-btn>
      <div class="my-6" align="center">
        <p>Copyright 2022</p>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    name: 'TCLKLogin',

    data: () => ({
      lk_login: "",
      lk_passwd: "",
    }),
    methods: {
      goAuth() {
        if ((this.lk_login != "")&&(this.lk_passwd != "")) {
          this.lk_login = this.lk_login.trim().toLowerCase()
          this.lk_passwd = this.lk_passwd.trim()
          this.axios.post(this.$store.state.apiURL + '/auth', { login: this.lk_login, passwd: this.lk_passwd })
          .then((response) => {
            if (response.data.code == 200) {
              this.dialog = false
//              this.$store.commit('wsURLMultihome', response.data.host)
              this.$store.commit('loggedIn', { login: this.lk_login, token: response.data.token })
              this.$router.push({ name: 'Main'})
            } else {
              alert('Неправильный логин или пароль')
            }
          });
        } else {
          alert('Введите логин и пароль')
        }
      },
    },
  }
</script>
